import React from 'react';
import { components, OptionProps } from 'react-select';
import { Tooltip } from 'src/common/Tooltip';
import * as S from './OptionWithHint.styles';

export interface HintableOption {
  label: string;
  value: string;
  hint?: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
}

export const OptionWithHint: React.FC<OptionProps<HintableOption, false>> = (props) => {
  const { data, children } = props;

  if (data.hint) {
    return (
      <components.Option {...props}>
        <S.OptionWrapper>
          <span>{children}</span>
          <Tooltip
            dataId={`select-option-${data.value}`}
            dataHtml={data.hint}
            place={data.place || 'right'}
            positionStrategy="fixed"
            infoIconStyle={{ transform: 'scale(0.8)' }}
          />
        </S.OptionWrapper>
      </components.Option>
    );
  }

  return <components.Option {...props} />;
};
